import React from 'react';
import CategoryTitle from '../../Basic/CategoryTitle/CategoryTitle.mjs';
import Container from '../../Basic/Container/Container.mjs';
import { StyledN12FlexContainer, StyledN12Events } from './N12Events.styles.mjs';

const N12Events = ({ title, href, widgetId }) => {
    return (React.createElement(Container, null,
        React.createElement(StyledN12FlexContainer, { direction: "column", gap: "1.5rem" },
            React.createElement(CategoryTitle, { uppercased: true, withArrow: true, withMarker: true, href: href }, title),
            React.createElement(StyledN12Events, { widgetId: widgetId }))));
};

export { N12Events as default };
//# sourceMappingURL=N12Events.mjs.map
